import api from './AxiosInstance';

export class ListFournisService {
  
  getAllListFournis = async () => {
    try {
      const response = await api.get(`/Fournisseur/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  getOneListFournis = async (fournisseurId) => {
    try {
      const response = await api.get(`/Fournisseur/${fournisseurId}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  updateListFournis= async ( payload) => {
    try {
     

      const response = await api.put(`/Fournisseur/update`, payload)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };


  addListFournis= async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/Benef/typeBenef/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  deleteListFournis= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/Benef/typeBenef/delete/${prestationId}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}


